import gql from "graphql-tag";

export const GetLatestPasswordChangeRecord = gql`
  query GetLatestPasswordChangeRecord($ProfileId: ID!) {
    GetLatestPasswordChangeRecord(ProfileId: $ProfileId) {
      RecordDate
    }
  }
`;
